var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcon24CreditCard = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.25 11.571h-3c-.412 0-.75-.385-.75-.857 0-.471.338-.857.75-.857h3c.412 0 .75.386.75.857 0 .472-.338.857-.75.857zm4.5 0h-1.5c-.412 0-.75-.385-.75-.857 0-.471.338-.857.75-.857h1.5c.412 0 .75.386.75.857 0 .472-.338.857-.75.857zm2.25.858c0 .472-.336.857-.75.857H3.75c-.414 0-.75-.385-.75-.857V8.143h12v4.286zM3 5.57c0-.472.336-.857.75-.857h10.5c.414 0 .75.385.75.857v.858H3V5.57zM14.25 3H3.75C2.51 3 1.5 4.154 1.5 5.571v6.858C1.5 13.846 2.51 15 3.75 15h10.5c1.24 0 2.25-1.154 2.25-2.571V5.57C16.5 4.154 15.49 3 14.25 3z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcon24CreditCard, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_24_ credit-card.e41fa04b.svg";
export { ForwardRef as ReactComponent };